/**
 * @fileoverview Agent definition for prose-comparer-committee-v2.
 *
 * This is a COMPOSITE agent that runs prose-comparer-v2 in parallel with
 * 5 different models and aggregates results via majority voting.
 *
 * Use case: From the comparison workbench, users can run an evaluation
 * committee that uses multiple AI models to judge content and return
 * a consensus decision based on plurality voting.
 *
 * @category writing.judgment.committee
 * @type composite
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'prose-comparer-committee-v2',
  kind: 'composite',
  name: 'Prose Comparer Committee',
  description: 'Runs prose comparison with 5 AI models in parallel and returns a majority vote decision.',
  category: 'writing',
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata ---
  metadata: {
    status: 'active',
    type: 'composite',
    addedIn: '2026-01',
    lastUpdated: '2026-01',
    usedBy: [
      'use-prose-comparer-committee-v2.ts',
      'ComparisonWorkbenchPage',
    ],
    // This composite runs prose-comparer-v2 multiple times with different models
    composedOf: [
      'prose-comparer-v2',
    ],
    relatedAgents: ['prose-comparer-v2', 'chapter-drafter-comparison-v2'],
    taxonomyPath: 'writing.judgment.committee',
  },
};
